import { render, staticRenderFns } from "./ThreadEnvelope.vue?vue&type=template&id=fc8b4380&scoped=true"
import script from "./ThreadEnvelope.vue?vue&type=script&lang=js"
export * from "./ThreadEnvelope.vue?vue&type=script&lang=js"
import style0 from "./ThreadEnvelope.vue?vue&type=style&index=0&id=fc8b4380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8b4380",
  null
  
)

export default component.exports